var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:_vm.btnVariant,attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("prepend-icon"),_vm._t("default"),_vm._t("append-icon")],2)}
var staticRenderFns = []

export { render, staticRenderFns }